import { useState, useEffect, memo, useCallback } from "react";
import { CSVLink } from "react-csv";
import AnimacionCarga from "../components/animacion_de_carga";
import BarraSuperior from "../components/barra_superior";
import BotonSOS from "../components/sos/boton_sos";
import { obtenerAnuncios } from "../../functions/consultas";
import Swal from "sweetalert2";
import { subirArchivoFirebase } from "../../functions/archivos_firebase";
import { crearRegistro, actualizarRegistro, eliminarRegistro } from "../../functions/crud";
import "bootstrap-icons/font/bootstrap-icons.css";

const COLUMNAS = [
  { label: "Fecha", key: "fecha" },
  { label: "Hora", key: "hora" },
  { label: "Título", key: "titulo" },
  { label: "Descripción", key: "descripcion" },
  { label: "Teléfono", key: "telefono" },
  { label: "Foto", key: "url_foto_1" }
];

const CATEGORIAS = [
  "Alquiler apartamento",
  "Venta apartamento",
  "Alquiler parqueadero",
  "Venta parqueadero",
  "Servicios",
  "Compra/Venta",
  "Otro"
];

const ESTRUCTURA_ANUNCIO_VACIO = {
  casa: "",
  categoria: "",
  contador: 0,
  correo: "",
  descripcion: "",
  estado: "Aprobado",
  fecha: "",
  hora: "",
  idUnico: "",
  motivo_rechazo: " ",
  precio: "0",
  sitio_web: " ",
  telefono: "",
  titulo: "",
  url_foto_1: "",
  url_foto_2: "",
  url_foto_3: "",
  url_foto_4: "",
  url_foto_5: "",
  url_foto_6: "",
  url_pdf: ""
};

const MisAnuncios = memo(() => {
  const [datos, setDatos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [modalAnuncio, setModalAnuncio] = useState(null);

  const obtenerFechaHora = () => {
    const ahora = new Date();
    return {
      fecha: ahora.toISOString().split('T')[0],
      hora: ahora.toTimeString().split(' ')[0].substring(0, 5),
      timestamp: ahora.toISOString().replace('T', ' ').replace('Z', '')
    };
  };

  const generarFormularioHTML = (datosAnuncio = null) => `
    <style>
      .swal2-input, .swal2-textarea, .swal2-select, .swal2-file {
        margin: 0 !important;
        width: 100% !important;
        box-sizing: border-box !important;
        padding: 7px 10px !important;
        border: 1px solid #d1d5db !important;
        border-radius: 5px !important;
        font-size: 13px !important;
      }
      .swal2-textarea { min-height: 70px !important; resize: vertical !important; }
      .swal2-file { padding: 8px 10px !important; border: 1px dashed #d1d5db !important; cursor: pointer !important; }
      .form-row { display:grid; grid-template-columns:1fr 1fr; gap:10px; margin-bottom:10px; }
      .form-field { display:flex; flex-direction:column; gap:4px; margin-bottom:10px; }
      .form-field label { color:#555; font-size:12px; font-weight:500; }
    </style>
    <div style="text-align:left;padding:12px 16px 4px;">
      <div class="form-row">
        <div class="form-field">
          <label>Categoría</label>
          <select id="categoria" class="swal2-select">
            <option value="">Selecciona...</option>
            ${CATEGORIAS.map(cat => `<option value="${cat}" ${datosAnuncio?.categoria === cat ? 'selected' : ''}>${cat}</option>`).join('')}
          </select>
        </div>
        <div class="form-field">
          <label>Título</label>
          <input id="titulo" class="swal2-input" placeholder="Título del anuncio" value="${datosAnuncio?.titulo || ''}">
        </div>
      </div>
      <div class="form-field">
        <label>Descripción</label>
        <textarea id="descripcion" class="swal2-textarea" placeholder="Describe tu anuncio...">${datosAnuncio?.descripcion || ''}</textarea>
      </div>
      <div class="form-row">
        <div class="form-field">
          <label>Teléfono</label>
          <input id="telefono" type="tel" class="swal2-input" placeholder="Teléfono de contacto" value="${datosAnuncio?.telefono || ''}">
        </div>
        <div class="form-field">
          <label>Precio (Opcional)</label>
          <input id="precio" type="number" class="swal2-input" placeholder="0" value="${datosAnuncio?.precio || '0'}">
        </div>
      </div>
      <div class="form-row">
        <div class="form-field">
          <label>Sitio Web (Opcional)</label>
          <input id="sitio_web" type="url" class="swal2-input" placeholder="https://..." value="${datosAnuncio?.sitio_web && datosAnuncio.sitio_web !== ' ' ? datosAnuncio.sitio_web : ''}">
        </div>
        <div class="form-field">
          <label>Imagen ${datosAnuncio ? '(vacío = mantener)' : '(Opcional)'}</label>
          <input id="archivo" type="file" accept="image/*" class="swal2-file">
        </div>
      </div>
      ${datosAnuncio?.url_foto_1 ? `
        <div style="text-align:center;background:#f8f9fa;padding:8px;border-radius:8px;margin-bottom:8px;">
          <img src="${datosAnuncio.url_foto_1}" style="max-width:100%;max-height:120px;border-radius:6px;">
        </div>
      ` : ''}
      <div id="preview" style="text-align:center;"></div>
    </div>
  `;

  const configurarEventosFormulario = () => {
    const archivo = document.getElementById("archivo");
    const preview = document.getElementById("preview");
    archivo.addEventListener("change", () => {
      const file = archivo.files[0];
      preview.innerHTML = file
        ? `<div style="background:#f8f9fa;padding:15px;border-radius:8px;border:2px dashed #d1d5db;">
             <img src="${URL.createObjectURL(file)}" style="max-width:100%;max-height:250px;border-radius:6px;display:block;margin:0 auto;">
           </div>`
        : "";
    });
  };

  const validarYObtenerDatos = () => {
    const categoria  = document.getElementById("categoria").value.trim();
    const titulo     = document.getElementById("titulo").value.trim();
    const descripcion = document.getElementById("descripcion").value.trim();
    const telefono   = document.getElementById("telefono").value.trim();
    const precio     = document.getElementById("precio").value.trim() || "0";
    const sitio_web  = document.getElementById("sitio_web").value.trim() || " ";
    const archivo    = document.getElementById("archivo").files[0];

    if (!categoria)  { Swal.showValidationMessage("La categoría es obligatoria");  return false; }
    if (!titulo)     { Swal.showValidationMessage("El título es obligatorio");      return false; }
    if (!descripcion){ Swal.showValidationMessage("La descripción es obligatoria"); return false; }
    if (!telefono)   { Swal.showValidationMessage("El teléfono es obligatorio");    return false; }

    return { categoria, titulo, descripcion, telefono, precio, sitio_web, archivo };
  };

  const subirArchivo = async (archivo, fecha) => {
    if (!archivo) return "";
    const nit = localStorage.getItem("CodigoCliente");
    const { timestamp } = obtenerFechaHora();
    return await subirArchivoFirebase(`uploads/${nit}/${fecha}/${timestamp}foto_0.jpeg`, archivo);
  };

  const construirAnuncio = (formValues, urlFoto, anuncioExistente = null) => {
    const { fecha, hora, timestamp } = obtenerFechaHora();
    return {
      ...ESTRUCTURA_ANUNCIO_VACIO,
      ...(anuncioExistente || {}),
      casa: formValues.casa,
      categoria: formValues.categoria,
      correo: formValues.correo,
      descripcion: formValues.descripcion,
      fecha, hora,
      idUnico: anuncioExistente?.idUnico || timestamp,
      precio: formValues.precio,
      sitio_web: formValues.sitio_web,
      telefono: formValues.telefono,
      titulo: formValues.titulo,
      url_foto_1: urlFoto
    };
  };

  const capturarDatos = useCallback(async () => {
    try {
      const data = await obtenerAnuncios();
      const correo = (localStorage.getItem("CorreoElectronico") || "").toLowerCase();
      const lista = Object.entries(data || {})
        .map(([id, item]) => ({ id, ...item }))
        .filter(item => (item.correo || "").toLowerCase() === correo)
        .sort((a, b) => new Date(`${b.fecha} ${b.hora || "00:00"}`) - new Date(`${a.fecha} ${a.hora || "00:00"}`));
      setDatos(lista);
    } catch (error) {
      console.error("Error al obtener anuncios:", error);
    } finally {
      setCargando(false);
    }
  }, []);

  const crearAnuncio = useCallback(async () => {
    const { value: formValues } = await Swal.fire({
      title: "Crear Anuncio",
      html: generarFormularioHTML(),
      didOpen: configurarEventosFormulario,
      showCancelButton: true,
      confirmButtonText: "Publicar",
      cancelButtonText: "Cancelar",
      width: 780,
      preConfirm: () => {
        const datos = validarYObtenerDatos();
        if (!datos) return false;
        return { ...datos, correo: localStorage.getItem("CorreoElectronico") || "", casa: localStorage.getItem("Direccion") || "" };
      }
    });
    if (!formValues) return;
    try {
      const { fecha } = obtenerFechaHora();
      const urlFoto = await subirArchivo(formValues.archivo, fecha);
      const anuncioData = { ...construirAnuncio(formValues, urlFoto), estado: "Pendiente" };
      const nit = localStorage.getItem("CodigoCliente");
      await crearRegistro(`coordi_ph/${nit}/anuncios/`, anuncioData);
      Swal.fire("Éxito", "Anuncio enviado, quedará visible cuando sea aprobado por la administración.", "success");
      capturarDatos();
    } catch (error) {
      console.error("Error al crear anuncio:", error);
      Swal.fire("Error", "No se pudo crear el anuncio", "error");
    }
  }, [capturarDatos]);

  const editarAnuncio = useCallback(async (anuncio) => {
    const { value: formValues } = await Swal.fire({
      title: "Editar Anuncio",
      html: generarFormularioHTML(anuncio),
      didOpen: configurarEventosFormulario,
      showCancelButton: true,
      confirmButtonText: "Guardar",
      cancelButtonText: "Cancelar",
      width: 780,
      preConfirm: () => {
        const datos = validarYObtenerDatos();
        if (!datos) return false;
        return { ...datos, correo: localStorage.getItem("CorreoElectronico") || anuncio.correo, casa: localStorage.getItem("Direccion") || anuncio.casa };
      }
    });
    if (!formValues) return;
    try {
      const { fecha } = obtenerFechaHora();
      const urlFoto = formValues.archivo ? await subirArchivo(formValues.archivo, fecha) : anuncio.url_foto_1 || "";
      const anuncioActualizado = { ...construirAnuncio(formValues, urlFoto, anuncio), estado: "Pendiente" };
      const nit = localStorage.getItem("CodigoCliente");
      await actualizarRegistro(`coordi_ph/${nit}/anuncios/${anuncio.id}`, anuncioActualizado);
      Swal.fire("Éxito", "Anuncio actualizado correctamente", "success");
      capturarDatos();
    } catch (error) {
      console.error("Error al actualizar anuncio:", error);
      Swal.fire("Error", "No se pudo actualizar el anuncio", "error");
    }
  }, [capturarDatos]);

  const eliminarAnuncio = useCallback(async (anuncio) => {
    const { isConfirmed } = await Swal.fire({
      title: '¿Eliminar Anuncio?',
      html: `
        <div style="text-align:left;padding:15px;">
          <div style="background:#f8f9fa;padding:15px;border-radius:8px;border-left:4px solid #e74c3c;">
            <strong style="display:block;margin-bottom:8px;color:#2c3e50;">${anuncio.titulo}</strong>
            <p style="color:#7f8c8d;margin:5px 0;font-size:14px;">Categoría: ${anuncio.categoria}</p>
            <p style="color:#7f8c8d;margin:0;font-size:14px;">${anuncio.descripcion}</p>
          </div>
          <p style="margin-top:15px;color:#e74c3c;">Esta acción no se puede deshacer</p>
        </div>
      `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar'
    });
    if (!isConfirmed) return;
    try {
      const nit = localStorage.getItem("CodigoCliente");
      await eliminarRegistro(`coordi_ph/${nit}/anuncios/${anuncio.id}`);
      Swal.fire({ title: 'Eliminado', text: 'Anuncio eliminado correctamente', icon: 'success', timer: 2000, showConfirmButton: false });
      capturarDatos();
    } catch (error) {
      console.error("Error al eliminar anuncio:", error);
      Swal.fire("Error", "No se pudo eliminar el anuncio", "error");
    }
  }, [capturarDatos]);

  useEffect(() => { capturarDatos(); }, [capturarDatos]);

  if (cargando) return <AnimacionCarga />;

  const estadoColor = (e) => e === "Aprobado" ? "#059669" : e === "Rechazado" ? "#dc2626" : "#d97706";
  const estadoBg   = (e) => e === "Aprobado" ? "#ecfdf5"  : e === "Rechazado" ? "#fef2f2"  : "#fffbeb";

  return (
    <>
      <BarraSuperior />

      {modalAnuncio && (
        <div onClick={() => setModalAnuncio(null)} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, padding: "20px" }}>
          <div onClick={(e) => e.stopPropagation()} style={{ background: "#fff", borderRadius: "16px", overflow: "hidden", width: "100%", maxWidth: "900px", boxShadow: "0 8px 40px rgba(0,0,0,0.3)", display: "flex", flexDirection: "column" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 20px", borderBottom: "1px solid #e5e7eb" }}>
              <span style={{ color: "#1f2937", fontWeight: "600", fontSize: "16px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{modalAnuncio.titulo}</span>
              <button onClick={() => setModalAnuncio(null)} style={{ background: "none", border: "none", color: "#6b7280", fontSize: "24px", cursor: "pointer", lineHeight: 1, padding: "0 4px" }}>×</button>
            </div>
            <img src={modalAnuncio.url_foto_1} alt={modalAnuncio.titulo} style={{ width: "100%", maxHeight: "65vh", objectFit: "contain", display: "block", background: "#f3f4f6" }} />
            <div style={{ padding: "16px 20px", borderTop: "1px solid #e5e7eb" }}>
              <span style={{ fontSize: "12px", fontWeight: "700", color: "#ff4747", textTransform: "uppercase", letterSpacing: "1px" }}>{modalAnuncio.categoria}</span>
              <p style={{ margin: "6px 0 0", color: "#6b7280", fontSize: "14px", lineHeight: "1.6" }}>{modalAnuncio.descripcion}</p>
              {modalAnuncio.precio && modalAnuncio.precio !== "0" && (
                <p style={{ margin: "6px 0 0", fontSize: "16px", fontWeight: "700", color: "#059669" }}>${Number(modalAnuncio.precio).toLocaleString("es-CO")}</p>
              )}
              <span style={{ fontSize: "12px", color: "#9ca3af", marginTop: "6px", display: "block" }}>{modalAnuncio.fecha} {modalAnuncio.hora}</span>
            </div>
          </div>
        </div>
      )}

      <div style={{ padding: "8px 16px 0", display: "flex", justifyContent: "flex-end", gap: 0 }}>
        <button onClick={capturarDatos} title="Refrescar"><i className="bi bi-arrow-clockwise" /></button>
        <CSVLink data={datos} headers={COLUMNAS} filename="mis_anuncios.csv" separator=";" style={{ padding: "7px 14px", margin: 2, backgroundColor: "#c0392b", color: "#fff", borderRadius: 7, fontSize: "0.82rem", fontWeight: 500, textDecoration: "none" }} title="Exportar"><i className="bi bi-download" /></CSVLink>
        <button onClick={crearAnuncio} title="Nuevo Anuncio"><i className="bi bi-plus-lg" /></button>
      </div>

      <div style={{ padding: "20px 16px 100px" }}>
        {datos.length === 0 ? (
          <div style={{ display: "flex", justifyContent: "center", marginTop: "60px" }}>
            <p style={{ color: "#9ca3af", fontSize: "15px" }}>Aún no has publicado ningún anuncio.</p>
          </div>
        ) : (
          <div style={{ width: "100%", overflowX: "auto", borderRadius: "12px", border: "1px solid #e5e7eb", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
              <thead>
                <tr style={{ background: "#f9fafb", borderBottom: "1px solid #e5e7eb" }}>
                  {["Categoría", "Título", "Descripción", "Precio", "Teléfono", "Fecha", "Estado", ""].map((h, i) => (
                    <th key={i} style={{ padding: "12px 16px", textAlign: "left", fontWeight: "600", color: "#374151", fontSize: "13px", whiteSpace: "nowrap" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {datos.map((anuncio, i) => (
                  <tr key={anuncio.id} style={{ borderBottom: i < datos.length - 1 ? "1px solid #f3f4f6" : "none", background: "#fff" }}>
                    <td style={{ padding: "12px 16px", color: "#ff4747", fontWeight: "600", fontSize: "12px", textTransform: "uppercase", whiteSpace: "nowrap" }}>{anuncio.categoria}</td>
                    <td style={{ padding: "12px 16px", color: "#1f2937", fontWeight: "600", maxWidth: "200px" }}>{anuncio.titulo}</td>
                    <td style={{ padding: "12px 16px", color: "#6b7280", maxWidth: "280px" }}>
                      <span style={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>{anuncio.descripcion}</span>
                    </td>
                    <td style={{ padding: "12px 16px", color: "#059669", fontWeight: "700", whiteSpace: "nowrap" }}>
                      {anuncio.precio && anuncio.precio !== "0" ? `$${Number(anuncio.precio).toLocaleString("es-CO")}` : "—"}
                    </td>
                    <td style={{ padding: "12px 16px", color: "#374151", whiteSpace: "nowrap" }}>{anuncio.telefono || "—"}</td>
                    <td style={{ padding: "12px 16px", color: "#9ca3af", whiteSpace: "nowrap" }}>{anuncio.fecha}</td>
                    <td style={{ padding: "12px 16px" }}>
                      <span style={{ fontSize: "12px", fontWeight: "600", color: estadoColor(anuncio.estado), background: estadoBg(anuncio.estado), border: `1px solid ${estadoColor(anuncio.estado)}40`, borderRadius: "20px", padding: "3px 10px", whiteSpace: "nowrap" }}>
                        {anuncio.estado}
                      </span>
                    </td>
                    <td style={{ padding: "12px 16px" }}>
                      <div style={{ display: "flex", gap: "6px", justifyContent: "flex-end" }}>
                        {anuncio.url_foto_1 && (
                          <button onClick={() => setModalAnuncio(anuncio)} style={{ padding: "5px 12px", fontSize: "13px", borderRadius: "6px", border: "1px solid #d1d5db", background: "#fff", color: "#374151", cursor: "pointer", whiteSpace: "nowrap" }}>Ver</button>
                        )}
                        <button onClick={() => editarAnuncio(anuncio)} style={{ padding: "5px 12px", fontSize: "13px", borderRadius: "6px", border: "1px solid #d1d5db", background: "#f9fafb", color: "#374151", cursor: "pointer" }}>✏ Editar</button>
                        <button onClick={() => eliminarAnuncio(anuncio)} style={{ padding: "5px 12px", fontSize: "13px", borderRadius: "6px", border: "1px solid #fca5a5", background: "#fef2f2", color: "#dc2626", cursor: "pointer" }}>× Eliminar</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <BotonSOS />
    </>
  );
});

export default MisAnuncios;
